module.exports = __webpack_public_path__ + "d7a5937d9beeb296ae8e991a7038c16b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/banana.png
// module id = 2597
// module chunks = 0